export default __webpack_public_path__ + "static/media/edit.82759b85.svg";